import { useTheme } from "@mui/material";
import { BarDatum, ResponsiveBar as NivoResponsiveBar, ResponsiveBarSvgProps } from "@nivo/bar";
import { LineSvgProps, ResponsiveLine as NivoResponsiveLine } from "@nivo/line";
import { MayHaveLabel, PieSvgProps, ResponsivePie as NivoResponsivePie } from "@nivo/pie";

type NivoTheme = LineSvgProps["theme"];

// Nivo writes its default font ("sans-serif", i.e. Arial on Windows) as an inline style on every SVG text node,
// so the app font is never inherited and has to be passed through the nivo theme. The ESLint no-restricted-imports
// rule points all nivo chart usages here so no chart can miss it.
function useThemeWithAppFont(nivoTheme: NivoTheme): NivoTheme {
    const theme = useTheme();
    return { ...nivoTheme, text: { fontFamily: theme.typography.fontFamily, ...nivoTheme?.text } };
}

export function ResponsiveBar<RawDatum extends BarDatum>(props: ResponsiveBarSvgProps<RawDatum>) {
    const theme = useThemeWithAppFont(props.theme);
    return <NivoResponsiveBar {...props} theme={theme} />;
}

export function ResponsiveLine(props: LineSvgProps) {
    const theme = useThemeWithAppFont(props.theme);
    return <NivoResponsiveLine {...props} theme={theme} />;
}

export function ResponsivePie<RawDatum extends MayHaveLabel>(props: Omit<PieSvgProps<RawDatum>, "width" | "height">) {
    const theme = useThemeWithAppFont(props.theme);
    return <NivoResponsivePie {...props} theme={theme} />;
}
